define('modules/editor/models/property_groups/page_conversion',['require','exports','module','./base'],function(require,exports,module){
  "use strict";
  var BasePropertyGroup = require("./base");
  module.exports = BasePropertyGroup.extend({
    name: "page:conversion",
    properties: ["skip", "conditionalExec", "reqConversion", "successMessage", "executionStep", "customizedPixel"],
    defaults: {
      "skip": false,
      "conditionalExec": false,
      "reqConversion": "",
      "successMessage": "",
      "executionStep": 0,
      "customizedPixel": ""
    }
  });
});

